import {api} from '@/api/factory';

class Categories {
    constructor() {}

    getVideoCategories() {
        return api.get('/v1/publisher/videos/categories')
    }

    getCategoriesContentManager() {
        return api.get('/v1/content-manager/categories')
    }
}

export default Categories;